import React from "react";
import Counter from "../counter";
import { Typography, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import _ from "@lodash";

const CounterItem = (props) => {

  const {
    text,
    image,
    attachment,
    attachmentIsLink,
    number,
    onClick,
  } = props;

  return (
    <Card
      style={{ height: 170, backgroundColor: "transparent", border: 0 }}
      onClick={text ? onClick : null}
    >
      <div style={{ margin: 15, display: "flex", alignItems: "center", gap: 25 }}>
        {
          Boolean(image) &&
          <img
            src={image}
            alt="img"
            style={{
              objectFit: "cover",
              borderRadius: "50%",
              height: "70px",
              width: "70px",
            }}
          />
        }
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10
          }}
        >
          {
            Boolean(number) &&
            <div className={"display-number-container"}>
              <Counter
                key={text}
                number={number}
              />
            </div>
          }
          {
            Boolean(text) &&
            <Tooltip title={text} arrow>
              <Typography
                className={"item-text"}
                style={{ textAlign: "left", fontSize: 14, fontWeight: 500 }}
              >
                {_.truncate(text.replace(/<(?:.|\n)*?>/gm, ""), { length: 70 })}
              </Typography>
            </Tooltip>
          }
          {
            Boolean(attachment) &&
            <Typography
              className="whiteText"
              style={{
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 700,
                textDecoration: "underline",
                textAlign: "left"
              }}
            >
              {attachmentIsLink ? _.truncate(attachment.replace(/<(?:.|\n)*?>/gm, ""), { length: 25 }) : getLocalizedString("downloadAttachment")}
            </Typography>
          }
        </div>
      </div>
    </Card>
  )
};

export default CounterItem;